import { render, staticRenderFns } from "./GuildTile.vue?vue&type=template&id=dd0cbe34&"
import script from "./GuildTile.vue?vue&type=script&lang=js&"
export * from "./GuildTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports